import { APIClient } from "../helpers/api_helper";

const api = new APIClient();

export const getDashboardData = async () => {
  try {
    // api_helper's interceptor already unwraps Axios responses and returns response.data
    const response = await api.get("user/ib/dashboard/v2");

    if (!response || typeof response !== "object") {
      throw new Error("Invalid API response");
    }

    return response;
  } catch (error) {
    console.error("Dashboard API Error:", error);

    // error is typically a message string from the interceptor
    if (typeof error === "string") {
      throw new Error(error);
    }

    throw new Error(error?.message || "Something went wrong");
  }
};